<div class="img-container">
  <div class="form-group">
    <input
      (change)="handleFileInput($event)"
      type="file"
      name="img[]"
      class="file-upload-default"
      #inputImage
    />
    <div class="input-group col-xs-12" (click)="openFileBrowser($event)">
      <input
        type="text"
        class="form-control file-upload-info"
        disabled
        [(ngModel)]="imageFileName"
      />
      <span class="input-group-append">
        <button class="file-upload-browse btn btn-primary" type="button">
          <span>Upload</span>
        </button>
      </span>
    </div>
  </div>

  <div *ngIf="imageUrl" class="mt-3 d-flex justify-content-center align-items-center" style="height: 300px;">
    <img [src]="imageUrl" alt="Preview" style="max-width: 100%; max-height: 300px;" />
  </div>
  
</div>

<div class="modal-footer">
  <button
    [disabled]="loading"
    type="button"
    class="btn btn-primary"
    (click)="onSubmit()"
  >
    <span *ngIf="loading" class="mr-3">
      <i class="fas fa-circle-notch loading"></i>
    </span>
    <span>Atualizar Logo</span>
  </button>

  <button
    *ngIf="imageUrl !== 'assets/images/placeholder.jpg'"
    [disabled]="loading"
    type="button"
    class="btn btn-primary"
    (click)="onDelete()"
  >
    <span *ngIf="loading" class="mr-3">
      <i class="fas fa-circle-notch loading"></i>
    </span>
    <span>Limpar Logo</span>
  </button>
</div>
